<script setup>
import { ref } from 'vue';
import service1Img from '../../../../assets/images/service1.png';
import service2Img from '../../../../assets/images/service2.png';
import service3Img from '../../../../assets/images/service3.png';
import service4Img from '../../../../assets/images/service4.png';
import service5Img from '../../../../assets/images/service5.png';
import service6Img from '../../../../assets/images/service6.png';

const services = ref([
  {
    id: 1,
    title: '睇命盤/睇八字',
    description:
      '睇命盤、睇八字,唔係迷信,而係了解自己、掌握未來嘅第一步。命理如鏡,幫你睇清性格同運勢,用正面心態迎接人生每個高低起伏。',
    image: service1Img,
    buttonText: '睇命盤',
    link: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
  },
  {
    id: 2,
    title: '法事祈福',
    description:
      '正統道教科儀,為你祈福求神、化解太歲、還陰債、補財庫,調和命運。幫你化解厄運、轉危為安、增財添福,對財運、姻緣、健康、事業等各方面都有助益,聚福增運。',
    image: service2Img,
    buttonText: '睇姻緣',
    link: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
  },
  {
    id: 3,
    title: 'BB起名',
    description: '為BB起一個獨特寓意、美好寓意嘅名字。',
    image: service3Img,
    buttonText: '起名服務',
    link: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
  },
  {
    id: 4,
    title: '家居風水/辦公室風水',
    description: '辦公室/陽宅平面圖風水睇法, 幫你搵出最旺財、旺人丁嘅風水寶位',
    image: service4Img,
    buttonText: '睇風水',
    link: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
  },
  {
    id: 5,
    title: '擇吉日',
    description: '婚嫁、新屋入伙、商鋪開張、剖腹產等等重要日子 為你精準揀個吉日吉時!',
    image: service5Img,
    buttonText: '擇吉日',
    link: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
  },
  {
    id: 6,
    title: '課程講座',
    description:
      '對風水命理、玄學術數有興趣? 機會嚟啦!大師親授陰陽宅風水、手面相、八字、卜卦等等,帶你走入風水殿堂,學習真正嘅中國智慧。',
    image: service6Img,
    buttonText: '學習課程',
    link: 'https://diversion.salesmartly.com/split/whatsapp/fi8cxf',
  },
]);
</script>

<template>
  <section class="service-list-section">
    <h2 class="section-title">服務列表</h2>
    <p class="section-subtitle">八字玄機,命運之謎,幫你睇通人生機遇同挑戰!</p>
    <div class="services-container">
      <div
        v-for="service in services"
        :key="service.id"
        class="service-card"
      >
        <div class="service-image-container">
          <img
            :src="service.image"
            :alt="service.title"
            class="service-image"
          />
        </div>
        <div class="service-content">
          <h3 class="service-title">{{ service.title }}</h3>
          <p class="service-description">{{ service.description }}</p>
          <a
            :href="service.link"
            target="_blank"
            rel="noopener noreferrer"
            class="service-button"
          >
            {{ service.buttonText }}
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.service-list-section {
  width: 100%;
  padding: 0.2rem 0.4rem;
  background: #ffffff;
}

.section-title {
  font-size: 0.8rem;
  color: #4c360a;
  text-align: center;
  margin-bottom: 0.75rem;
}

.section-subtitle {
  font-size: 0.7rem;
  color: #4c360a;
  text-align: center;
  margin-bottom: 1rem;
  line-height: 1.6;
}

.services-container {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.service-card {
  width: 100%;
  background: #ffffff;
  overflow: hidden;
  border: 0.06rem solid #ccc;
  padding: 1rem 0.4rem 0.2rem;
}

.service-image-container {
  width: 100%;
  overflow: hidden;

  .service-image {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
  }
}

.service-content {
  padding: 0.5rem 0;

  .service-title {
    font-size: 0.6rem;
    font-weight: 600;
    color: #333333;
    margin-bottom: 0.3rem;
    line-height: 1.4;
    text-align: center;
  }

  .service-description {
    font-size: 0.5rem;
    color: #666666;
    line-height: 1.8;
    margin-bottom: 0.3rem;
  }

  .service-button {
    display: block;
    width: 100%;
    padding: 0.2rem 1.5rem;
    background: #e5ae40;
    color: #000000;
    font-size: 0.5rem;
    font-weight: 600;
    text-decoration: none;
    border-radius: 1.875rem;
    text-align: center;
    transition: all 0.3s ease;

    &:active {
      background: #d4af37;
      transform: scale(0.98);
    }
  }
}
</style>
